export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-brush/src/constant.js
// module id = ../../../../d3-brush/src/constant.js
// module chunks = 4